import * as React from 'react';
import styled from 'styled-components';

import { VariantsGrid } from '@process-advisor/process-miner/filters/variants/variantsGrid';
import { SingleBlock } from '@process-advisor/process-miner/filters/variants/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

const GridOptions = styled.div`
    width: 100%;
`;


const RowApply = styled.div`
  display: grid;
  justify-content: center;
  padding-top: 10px;
`;

const HelpText = styled.div`
    font-size: 12px;
    color: #6b778c;
    font-style: italic;
    padding: 2px 12px 8px;
    text-align: center;
    width: 100%;
    flex-basis: 100%;  // Added - ensures full width in flex container
`;
export const VariantsFilter = (mode) => {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const [applyEnabled,setApplyEnabled] = React.useState<boolean>(true);

    async function onApply () {
        await openProgressModal({status: 'Processing Step Filters'})
        await sleep(50)
    
        await apiProvider.applyVariantFilter({mode: mode.mode})
            setApplyEnabled(true)
            closeProgressModal()
        };
    

    return (
    <Wrapper>
        <SingleBlock borderBottom>
            <VariantsGrid setApplyEnabled={setApplyEnabled} selectionMode='multiple' mode={mode}/>
        </SingleBlock>
        <GridOptions>
            <RowApply>
                <Button label='Apply' onClick={onApply} disabled={applyEnabled}/>
            </RowApply>
        </GridOptions>
        <HelpText>Right mouse click a variant for analysis options</HelpText>
        <AlertMessage/>
    </Wrapper>
    )
};